import { policiesIsAccepted, acceptPolicies } from './utils/cookies'
import { isValidCNPJ, isValidCPF } from './utils/validators'

export class Negotiation {

  constructor() {
    this.identificationField = $('#identification')
    this.cnpjRadios = $('#cnpj__radios')
    this.cpfRadios = $('#cpf__radios')
    this.exampleModal = $('#exampleModal')
    this.avisoType = $('.aviso-type')
    this.btnPayDebts = $('#btn-pay-debts')
    this.cookieModal = $('#cookieModal')
    this.formMessage = $('#form-message')
    this.modalTitle = $('#modal-title')
    this.avisoContentBtn = $(".aviso-content button")
  }

  submitButtonLoading() {
    $("#form-text-submit").hide();
    $("#form-submit-loading").show();
    return;
  }

  submitButtonReset() {
    $("#form-text-submit").show();
    $("#form-submit-loading").hide();
    return;
  }

  verifyCnpj(inputValue) {
    if (inputValue.length < 18) {
      $('#exampleModal')
        .modal('toggle')
        .addClass('d-flex')
      $('.aviso-type').text('CNPJ')
      return false
    }
    if (inputValue.length == 18) {
      const isValid = isValidCNPJ(inputValue)
      if (!isValid) {
        $('#exampleModal')
          .modal('toggle')
          .addClass('d-flex')
        $('.aviso-type').text('CNPJ')
      } else if (isValid) {
        return true
      }
    }
  }

  verifyCpf(inputValue) {
    if (inputValue.length < 14) {
      $('#exampleModal')
        .modal('toggle')
        .addClass('d-flex')

      $('.aviso-type').text('CPF')
      return false
    }
    if (inputValue.length == 14) {
      const isValid = isValidCPF(inputValue)
      if (!isValid) {
        $('#exampleModal')
          .modal('toggle')
          .addClass('d-flex')
        $('.aviso-type').text('CPF')
      } else {
        return true
      }
    }
  }

  verifyDocumentListener() {
    const inputValue = this.identificationField.val()
    if (this.cnpjRadios.is(':checked')) return this.verifyCnpj(inputValue)
    if (this.cpfRadios.is(':checked')) return this.verifyCpf(inputValue)
    return this.verifyCpf(inputValue)
  }

  appendModalForm(title, msg, btnTitle) {
    this.formMessage.html(msg)
    this.modalTitle.html(title)
    this.avisoContentBtn.html(btnTitle)
    this.exampleModal.modal('toggle')
  }

  acceptCookies() {
    acceptPolicies()
    this.btnPayDebts
      .attr("type", "submit")
      .click()
  }

  showFormModal(e) {
    const negotiation = new Negotiation();
    $(".aviso-content button").attr('id', 'accept__cookies__warning__btn')
    $(".aviso-close img").attr('id', 'btn_close_content')

    const text = `
      Você precisa primeiro aceitar a nossa
      <a class="link-to-policies" target="_blank" href="/politicas-de-privacidade">Política de Privacidade</a>
      caso queira negociar.`

    $('#accept__cookies__warning__btn').click(() => { negotiation.acceptCookies() })
    $('#btn_close_content').click(() => { negotiation.submitButtonReset() })

    if (!policiesIsAccepted()) {
      if (e) {
        e.preventDefault()
      }
      negotiation.appendModalForm('Alto lá!', text, "Prosseguir")
      negotiation.cookieModal.css('display', 'none')
    }
  }

  permitSaveCookies() {
    acceptPolicies()
    this.cookieModal.css('display', 'none')
  }

  static dialogPrivacyListener() {
    const target = document.querySelector(".aviso-content")
    const negotiation = new Negotiation();

    document.addEventListener('click', (event) => {
      const withinBoundaries = event.composedPath().includes(target);
      let isLoading = $("#form-submit-loading").is(':visible');

      if (!withinBoundaries && isLoading) {
        negotiation.submitButtonReset();
      }
    })
  }

  static saveCookiesListener() {
    const negotiation = new Negotiation()
    $("#acceptCookie").click(() => { negotiation.permitSaveCookies() })
  }

  /**
   * Se existir o Referrer então cria ele como um campo oculto no formulário onde o cliente informa o documento.
   * O valor dele será enviado no parâmetro "utm_source" para o módulo de negociação junto com o utm_medium=referral
   */
  static setReferrer() {
    if (document.referrer) {
      $("#referrer").val(document.referrer);
    }
  }

  static verifyKeyCodeListener() {
    const negotiation = new Negotiation()
    negotiation.identificationField.keydown(event => {
      const keycode = (event.keyCode ? event.keyCode : event.which);
      if (keycode == '13') {
        const isValid = negotiation.verifyDocumentListener()
        if (!isValid) event.preventDefault();
      }
    })
  }

  static submitDocumentFormListener() {
    const negotiation = new Negotiation();
    const form = $('#negocie-form');
    form.submit(event => {
      negotiation.submitButtonLoading();
      $.ajax({
        type: form.attr('method'),
        url: form.attr('action'),
      }).done(function () { negotiation.submitButtonReset(); });

      negotiation.showFormModal(event)
    })

    $('#btn-pay-debts')
      .bind('mousedown', event => {
        negotiation.modalTitle.text('Alto lá!')
        $(".aviso-content > img").attr('src', '/static/images/icons/alert.png')
        negotiation.formMessage.html('Preencha corretamente o seu <span class="aviso-type"></span>.')
        negotiation.avisoContentBtn.text('Ok')

        const isValid = negotiation.verifyDocumentListener()
        if (!isValid) event.preventDefault();
      })
      .on('keypress', () => {
        if ($('#btn-pay-debts').attr("type") == 'button') {

          negotiation.showFormModal()
        }
      })
  }

}